import React from 'react';
import {
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';

function Input({answer}) {

  return (
    <Row>
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap',marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="8">
                <Form.Group>
                  <Form.Label>Auditee's Answer</Form.Label>
                  <p>{answer.ANSWER_DESC ?? (
                      <span className="text-danger">Not answered yet</span>
                  )}</p>
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group>
                  <Form.Label>Attachment(s)</Form.Label>
                    {answer.answerAttachments && answer.answerAttachments.length > 0
                      ? (
                        <span className="form-control"
                          style={{
                            maxHeight: `200px`,
                            height: `200px`,
                            overflowY: `scroll`,
                            marginBottom: `10px`
                          }}
                        >
                          {answer.answerAttachments.map((attachment, key) => (
                            <div key={key} className="font-icon-detail">
                              <i className="nc-icon nc-attach-87"></i>{' '}
                              <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`} target="_blank" rel="noopener noreferrer">
                                {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                              </a>
                            </div>
                          ))}
                        </span>
                      )
                      : <p>No attachment uploaded.</p>
                    }
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Input;